import app from 'flarum/common/app';

/**
 * 产品
 */
export default class ProductListState {
  loadedIncludes?: Set<string>;

  async load(includes: string[] = []) {
    if (!this.loadedIncludes) {
      return this.query(includes);
    }

    const unloadedIncludes = includes.filter((include) => !this.loadedIncludes!.has(include));

    if (unloadedIncludes.length === 0) {
      return Promise.resolve(app.store.all('products'));
    }

    return this.query(unloadedIncludes);
  }

  async query(includes: string[] = []) {
    this.loadedIncludes ??= new Set();

    return app.store.find('products').then((val) => {
      includes.forEach((include) => this.loadedIncludes!.add(include));
      return val;
    });
  }
}
